import styled from 'styled-components';

const SwitchContainer = styled.div`
  position: relative;
  margin: 8px 8px 0 8px;
`;

const SwitchSlider = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 32px;
  border-radius: 20px;
  background-color: #191a1a;
  transition: background-color 0.2s;
  transition: 0.2s;
  cursor: pointer;
  border: 1px solid #caccce;

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  &::after {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    top: 3px;
    border-radius: 50%;
    background-color: white;
    transition: 0.2s;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
  }
`;

const SwitchInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  &:after {
    border: 1px solid red;
  }
  &:checked + ${SwitchSlider} {
    background: #00e88f;
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      margin-left: 28px;
      transition: 0.2s;
    }
  }
`;

const Dot = styled.span`
  right: 8px;
  width: 8px;
  height: 8px;
  border: 2px solid #96999c;
  border-radius: 50%;
`;

const VerticalLine = styled.span`
  left: 10px;
  border-left: 2px solid #191a1a;
  height: 10px;
`;

export { Dot, SwitchContainer, SwitchInput, SwitchSlider, VerticalLine };
